/**
 * #149/#154 — titulos PENDENTES do CP vivo com previsao de pagamento JA passada.
 *
 * Nivel FORA DA SERIE: nao pertencem a nenhuma barra (o grafico so desenha dias
 * >= hoje), entao vivem num bloco proprio na tela do Fluxo (PrevisaoVencidaCard).
 * Mesmo padrao dos hooks da casa: cache module-level + estado {data, isLoading,
 * error}. Falha de rede/5xx -> data null + error (o card diz "indisponivel",
 * NUNCA mostra 0 — zero silencioso e a classe de erro que este bloco existe
 * para expor).
 */
import { useEffect, useState } from "react";
import { getPrevisaoVencida } from "../api/client";
import type { PrevisaoVencidaResponse } from "../api/types";

const TTL_MS = 180 * 1000; // mesma cadencia do useFluxoV2 (CP vivo muda por sync)

interface CacheEntry {
  expiresAt: number;
  promise: Promise<PrevisaoVencidaResponse>;
}

let cache: CacheEntry | null = null;

export function invalidatePrevisaoVencidaCache(): void {
  cache = null;
}

export interface UsePrevisaoVencidaState {
  data: PrevisaoVencidaResponse | null;
  isLoading: boolean;
  error: Error | null;
}

export function usePrevisaoVencida(): UsePrevisaoVencidaState {
  const [state, setState] = useState<UsePrevisaoVencidaState>({
    data: null,
    isLoading: true,
    error: null,
  });

  useEffect(() => {
    let cancel = false;
    const now = Date.now();
    if (!cache || cache.expiresAt < now) {
      cache = { expiresAt: now + TTL_MS, promise: getPrevisaoVencida() };
    }
    cache.promise
      .then((data) => {
        if (!cancel) setState({ data, isLoading: false, error: null });
      })
      .catch((e: unknown) => {
        cache = null; // nao cacheia falha: proximo mount tenta de novo
        if (!cancel)
          setState({ data: null, isLoading: false, error: e instanceof Error ? e : new Error(String(e)) });
      });
    return () => {
      cancel = true;
    };
  }, []);

  return state;
}
